import { RefundActionResponseDto, TransactionItemSummaryV2Dto, ValidTransactionStatusEnum } from '@inosio/payments-sdk';
import { format } from 'date-fns';

// removes dashes (-) from string literals
export const removeDashes = (data: string) => {
  return data && data.split('-').join('');
};

export const confirmationText = `Thank you for submitting your data for review. We will follow up with you if we have any questions.
Typically we are able to approve customers in less than 1 business day, however if errors/omissions are found we will need to follow up with you via email.
Our goal is to get you approved for processing as quickly as possible.
While we are working on this you should configure your accounting software integration.`;

export const incompleteApplicationtext = `Inosio Payment Processing Application Incomplete
This application is required for processing payments and using the application. 
You can configure your integration and explore the application, however, no functionality will work until this application is completed and submitted. `;

export const GetExtendedTransactionStatus = (transDetails: TransactionItemSummaryV2Dto | RefundActionResponseDto) => {
  let transStatus = transDetails.Status as ValidTransactionStatusEnum;
  let refundDetails = transDetails.RefundDetails;

  switch (transStatus) {
    case ValidTransactionStatusEnum.Pending:
    case ValidTransactionStatusEnum.Cancelled:
      return transStatus;
    case ValidTransactionStatusEnum.Completed:
      //Completed, but there was a refund
      //if Refund is Approved or Issued
      if (refundDetails && refundDetails.TargetIssueDate) return `Refund ${refundDetails.Status} - Issue Date ${format(new Date(refundDetails.TargetIssueDate), 'MM/dd/yyyy')}`;
      //if Refund is Requested or denied
      if (refundDetails && ['Requested'].includes(refundDetails.Status)) return `Refund ${refundDetails.Status}`;
      //No refund, just show completed
      else return transStatus;
    case ValidTransactionStatusEnum.Returned:
      //if transaction is returned, then return status and reason code as well
      return `${transStatus} - ${transDetails?.ReturnDetails?.ReturnCode}: ${transDetails?.ReturnDetails?.ReturnDescription}`;
    case ValidTransactionStatusEnum.Refunded:
      //if the transaction is refunded, show the issue date as well
      if (refundDetails?.TargetIssueDate) return `${transStatus} - Issue Date ${format(new Date(refundDetails.TargetIssueDate + 'T00:00:00'), 'MM/dd/yyyy')}`;
      else return transStatus;
    case ValidTransactionStatusEnum.Chargedback:
      return transStatus;
  }
};